export class CoilCalculator {
	calculationType = 'organicCoatedSteel';
	nominalThickness = 0;
	metallicCoatingTypeDensity = 0;
	metallicCoatingThickness = 0;
	totalPaintThickness = 0;
	organicCoatedFilmThickness = 0;
	innerDiameter = 0;
	width = 0;
	additionalDataChoice = '';
	additionalData = 0;
}

export class CoilCalculatorResult {
	coilOuterDiameter = 0;
	coilWeight = 0;
	coilLength = 0;
	specificWeight = 0;
	resultCalculated = false;
}
